import React from 'react';
import { Box, TextField, Typography, Button, MenuItem } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
// import AreYouSureModal from '../../../components/AreYouSureModal';

const _PASSWORD = "aone0819";

function CopyPrevWeekZoomAssignModal({
    admin_name,
    enqueueSnackbar,
    colors,
    socketConnected,
    socket,
    copyPrevWeekZoomAssignOpen,
    handleCopyPrevWeekZoomAssignClose,
    thisWeek,
    isThisAdminInViewMode,
}) {

    // Copy scope: "week" = whole week, or a specific current-week date (YYYY-MM-DD).
    // (A non-empty sentinel is used so the Select shows the "Whole week" label.)
    const [selectedDate, setSelectedDate] = React.useState("week");
    const isSingleDay = selectedDate !== "week";
    const targetDayLabel = isSingleDay ? dayjs(selectedDate).format("dddd") : "";

    // Reset the scope back to "whole week" each time the modal is opened.
    React.useEffect(() => {
        if (copyPrevWeekZoomAssignOpen) {
            setSelectedDate("week");
            setPassword("");
        }
    }, [copyPrevWeekZoomAssignOpen]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        maxHeight: 800,
        overflowY: "auto",
        bgcolor: colors.primary[600],
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    // const [areYouSureModalOpen, setAreYouSureModalOpen] = React.useState(false);
    const [password, setPassword] = React.useState("");

    const handleCopyPrevWeekZoomAssign = async () => {
        // setAreYouSureModalOpen(false);

        if (!socketConnected) {
            enqueueSnackbar("Not connected to the server.", { variant: "error" });
            return;
        }

        try {
            socket.emit("put.EventCopyPrevWeekZoomAssign", {
                admin_name,
                thisWeek,
                targetDate: isSingleDay ? selectedDate : null,
            });

            setPassword("");
            handleCopyPrevWeekZoomAssignClose();
        } catch (error) {
            enqueueSnackbar("Error copying Zoom assignments from previous week.", { variant: "error" });
        }
    };

    return (
        <Modal
            aria-labelledby="copy-prev-week-zoom-assign-modal-title"
            aria-describedby="copy-prev-week-zoom-assign-modal-description"
            open={copyPrevWeekZoomAssignOpen}
            onClose={handleCopyPrevWeekZoomAssignClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={copyPrevWeekZoomAssignOpen}>
                <Box sx={style}>
                    <Typography variant="h4" color={colors.primary[450]}>
                        {isSingleDay
                            ? `Copy Zoom Assignments from Previous ${targetDayLabel}`
                            : "Copy Zoom Assignments from Previous Week"}
                    </Typography>
                    <CloseIcon sx={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }} onClick={handleCopyPrevWeekZoomAssignClose} />
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            mt: 2,
                            flexWrap: "wrap",
                        }}
                    >
                        <Typography variant="h5" color={colors.grey[700]}>
                            {isSingleDay
                                ? `(This will copy the Zoom assignments from last ${targetDayLabel} to ${targetDayLabel} of the week you are currently viewing.)`
                                : "(This will copy the Zoom assignments from the previous week to the week you are currently viewing.)"}
                        </Typography>
                        <TextField
                            select
                            label="Copy scope"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            sx={{ mt: 3, width: 320 }}
                        >
                            <MenuItem value="week">Whole week</MenuItem>
                            {(thisWeek || []).map((d) => (
                                <MenuItem key={d} value={d}>
                                    {dayjs(d).format("dddd (MM-DD)")}
                                </MenuItem>
                            ))}
                        </TextField>
                        <br />
                        <Typography color={colors.primary[450]}>
                            Be aware that:
                        </Typography>
                        <ul style={{ margin: 0 }}>
                            <li>
                                if a module in the current week already has a Zoom assigned, it will NOT be overwritten.
                            </li>
                            <li>
                                if a module in the current week is, for example, the first module of the course, meaning it has no previous module, it will remain unchanged.
                            </li>
                            <li>
                                if a previous module of the current week module is not assigned to any Zoom, the current week module will not be assigned to any Zoom.
                            </li>
                        </ul>
                        <TextField
                            id="password"
                            label="Password"
                            variant="outlined"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            sx={{ mt: 4, width: 200, mx: "auto" }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            mt: 4,
                        }}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{ width: 200, mt: 2 }}
                            onClick={() => {
                                if (password !== _PASSWORD) {
                                    enqueueSnackbar("Incorrect password.", { variant: "error" });
                                    return;
                                }
                                handleCopyPrevWeekZoomAssign();
                            }}
                            disabled={isThisAdminInViewMode}
                        >
                            Copy
                        </Button>
                        {/* <AreYouSureModal
                            colors={colors}
                            open={areYouSureModalOpen}
                            setOpen={setAreYouSureModalOpen}
                            title="Are you sure?"
                            message="This will overwrite the Zoom assignments in the current week."
                            onConfirm={handleCopyPrevWeekZoomAssign}
                        /> */}
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ width: 200, mt: 2 }}
                            onClick={handleCopyPrevWeekZoomAssignClose}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};

export default CopyPrevWeekZoomAssignModal